
import React, { ReactNode } from 'react';
import { CopilotKit } from '@copilotkit/react-core';
import { useAuth } from '@/contexts/auth/AuthContext';

interface CopilotProviderProps {
  children: ReactNode;
}

export const CopilotProvider: React.FC<CopilotProviderProps> = ({ children }) => {
  const { user } = useAuth();
  
  // Using the Copilot Kit API key provided by the user
  const copilotApiKey = "ck_pub_305a21e9c39001e54f102cb440848e10";
  
  return (
    <CopilotKit 
      publicApiKey={copilotApiKey}
    >
      {children}
    </CopilotKit>
  );
};
